import { Col, Divider, Row } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ title }) => (
  <Row>
    <Col span={24}>
      <span className="personalDocumentsForm__titleHeader">{title}</span>
    </Col>
    <Divider style={{ marginTop: 10, marginBottom: 0, marginLeft: '-4%' }} />
  </Row>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Header;
